import { Question } from "@/types/custom";

export const questions: Question[] = [
  {
    id: "title",
    question: "What's the name of your activity?",
    type: {
      input: "input",
      inputType: "text",
    },
  },
  {
    id: "description",
    question: "Describe your activity. What makes it special?",
    type: {
      input: "textarea",
      inputType: "text",
    },
  },
  {
    id: "duration",
    question: "How long will this activity take?",
    type: {
      input: "input",
      inputType: "number",
    },
    suffix: "hours",
  },
  {
    id: "cost",
    question: "What's the expected cost per person?",
    type: {
      input: "input",
      inputType: "number",
    },
    prefix: "$",
  },
  {
    id: "categories",
    question: "What type of activity is this? (Select up to 3)",
    type: {
      input: "types",
      inputType: "text",
    },
  },
  {
    id: "location",
    question: "Where is this activity located?",
    type: {
      input: "location",
      inputType: "text",
    },
  },
  {
    id: "images",
    question: "Add photos that best represent your activity",
    type: {
      input: "image",
      inputType: "text",
    },
  },
];

export const typeToIconClass: Record<string, string> = {
  historical: "fa-regular fa-monument",
  religious: "fa-regular fa-church",
  restaurants: "fa-regular fa-fork-knife",
  shopping: "fa-regular fa-shopping-cart",
  clubs: "fa-regular fa-champagne-glasses",
  theatre: "fa-regular fa-theater-masks",
  museum: "fa-regular fa-building-columns",
  "art gallery": "fa-regular fa-palette",
  "national park": "fa-regular fa-trees",
  viewpoint: "fa-regular fa-binoculars",
  parks: "fa-regular fa-tree",
  "food market": "fa-regular fa-pot-food",
  restaurant: "fa-regular fa-fork-knife",
  bar: "fa-regular fa-glass-whiskey",
  stadium: "fa-regular fa-court-sport",
  "hiking trail": "fa-regular fa-person-hiking",
  wildlife: "fa-regular fa-paw",
  beach: "fa-regular fa-umbrella-beach",
  waterfall: "fa-regular fa-water",
  "amusement park": "fa-regular fa-roller-coaster",
  lake: "fa-regular fa-water-ladder",
};
